import React from 'react'
import SvgAlertCircleFilledUpdated from 'src/components/Svgs/SvgAlertCircleFilledUpdated'
import { css } from 'styled-components'

interface TakeNoteBulletProps {
  className?: string
}

const TakeNoteBullet: React.FC<React.PropsWithChildren<TakeNoteBulletProps>> = (
  props,
) => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
      `}
    >
      <div>
        <SvgAlertCircleFilledUpdated
          css={css`
            margin-right: 4px;
            transform-origin: left;
            transform: scale(1);
          `}
        />
      </div>
      {props.children}
    </div>
  )
}

export default TakeNoteBullet
